module.exports = __webpack_public_path__ + "img/logo.7817ade5.png";